import { newE2EPage } from "@stencil/core/testing";

describe("uic-thumbnail-item", () => {
    it("renders default", async () => {
        const page = await newE2EPage({
            html: `<uic-thumbnail-item><img src="" alt=""></uic-thumbnail-item>`
        });
        const el = await page.find("uic-thumbnail-item");
        expect(el).toMatchSnapshot();
    });

    it("renders icon", async () => {
        const page = await newE2EPage({
            html: `<uic-thumbnail-item icon="uic:plus"><img src="" alt=""></uic-thumbnail-item>`
        });
        const el = await page.find("uic-thumbnail-item");
        expect(el).toMatchSnapshot();
    });
});
